<template>
    <div class="flex flex-col">
        <div class="mb-md">
            <h1 class="m-0 text-md">
                Redigera  {{ editType === 'address_type' ? 'fastighetstyp' : 'HP-meter' }}
            </h1>
        </div>

        <form v-loading="loading" @submit.prevent="save">
            <div v-if="editType === 'address_type'">
                <select-input
                    v-model="addressType"
                    name="address_type"
                    :options="address.address_type_labels"
                >
                    Välj fastighetstyp
                </select-input>
            </div>

            <div v-if="editType === 'hp_meter'">
                <text-input
                    v-model="housePassedMeter"
                    name="hp_m"
                    label="HP-meter"
                    :required="true"
                    type="number"
                />
            </div>

            <div class="flex justify-between flex-col-reverse md:flex-row">
                <button
                    type="button"
                    class="btn is-ghost btn-lg"
                    @click="$emit('changeView', 'address-details-list')"
                >
                    Avbryt
                </button>
                <button
                    type="submit"
                    class="btn btn-lg is-primary mb-md md:mb-0"
                >
                    <font-awesome-icon
                        v-if="loading"
                        icon="spinner"
                        class="mr-sm"
                        spin
                    />
                    Spara
                </button>
            </div>
        </form>

        <alert
            v-if="error"
            type="error"
            icon="fa-exclamation-circle"
            :initial-body="error"
            class="text-neutral-darkest mt-lg"
        />
    </div>
</template>
<script>
    export default {
        props: {
            address: {
                type: Object,
                required: true,
            },
            editType: {
                type: String,
                required: true,
            },
        },

        data() {
            return {
                loading: false,
                housePassedMeter: this.address.hp_m,
                addressType: this.address.address_type,
                error: null,
            };
        },

        methods: {
            async save() {
                try {
                    this.loading = true;
                    const response = await axios.patch(route('api.addresses.update', this.address.id), {
                        hp_m: this.housePassedMeter,
                        address_type: this.addressType,
                        delivery_project_id: this.address.delivery_project_id,
                    });

                    this.loading = false;
                    flash_success('Address uppdaterad!');
                    this.$emit('updateAddress', response.data);
                    this.$emit('changeView', 'address-details-list');
                } catch (error) {
                    this.loading = false;

                    if (error.response.data.message) {
                        this.error = error.response.data.message;

                        return;
                    }

                    this.error = 'Åtgärden misslyckades.';
                }
            },
        },
    };
</script>
